export default __webpack_public_path__ + "static/media/snapchat.07945902.svg";